// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eRRf","badges":"styles_badges__1dlMr"};